
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Trash } from 'lucide-react';
import { ReferralURLConfig } from '@/utils/config/types';
import ReferralBannerUpload from '@/components/referral/ReferralBannerUpload';
import ReferralURLTestLink from './ReferralURLTestLink';

interface ReferralURLCardProps {
  url: ReferralURLConfig;
  onEdit: (url: ReferralURLConfig) => void;
  onDelete: (id: string) => void;
  onBannerUpdate: (urlId: string, newBanners: any[]) => Promise<void>;
}

const ReferralURLCard: React.FC<ReferralURLCardProps> = ({
  url,
  onEdit,
  onDelete,
  onBannerUpdate
}) => {
  return (
    <Card className={url.isDefault ? 'border-primary' : ''}>
      <CardHeader className="py-4 px-6">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">{url.name}</CardTitle>
          <div className="flex items-center gap-2">
            {url.isDefault && (
              <span className="text-xs bg-primary/10 text-primary px-2 py-1 rounded">
                Default
              </span>
            )}
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={() => onEdit(url)}
            >
              Edit
            </Button>
            <Button 
              variant="ghost" 
              size="sm"
              disabled={url.isDefault} 
              onClick={() => onDelete(url.id)}
            >
              <Trash className="h-4 w-4 text-destructive" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="py-2 px-6">
        <div className="space-y-4">
          <div className="text-sm text-muted-foreground overflow-hidden text-ellipsis">
            {url.baseUrl}
          </div>
          
          <ReferralURLTestLink url={url} />
          
          <ReferralBannerUpload
            banners={url.banners || []}
            onBannerUpdate={(newBanners) => onBannerUpdate(url.id, newBanners)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralURLCard;
